module.exports = __webpack_public_path__ + "theme/assets/img/45afbfeea6b61e38a5158ab121f817b0.png";